{
  "cycle.entite.documentation_pages": "Project documentation pages",
  "cycle.entite.politiques_approbation_environnement": "Environment approval policies",
  "journalAudit.action.docs.regenerated": "Project documentation regenerated",
  "journalAudit.action.environment.approval_policy_changed": "Environment approval policy changed"
}
